import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'
import app from '@/components/mode/app'
import kefu from '@/components/mode/kefu'
import gamePage from '@/components/mode/gamePage'
import hongbao from '@/components/mode/hongbao'
import activity from '@/components/mode/activity'
import zhongjian from '@/components/mode/zhongjian'


import zhanzhu from '@/components/mode/zhanzhu'
import mine from '@/components/mode/mine'



import login from '@/components/login'
import activityInfo from '@/components/activityInfo'

import wenInfo from '@/components/wenInfo'

import zhanzhuye from '@/components/zhanzhuye'
import vip from '@/components/vip'
import applyagent from '@/components/applyagent'
import boutBallBet from '@/components/boutBallBet'
import boutBallBetInfo from '@/components/boutBallBetInfo'
import message from '@/components/message'
import fanshui from '@/components/fanshui'
import userInfo from '@/components/userInfo'
import userCent from '@/components/userCent'
import wallet from '@/components/wallet'
import addUsdtCard from '@/components/addUsdtCard'
import addBankCard from '@/components/addBankCard'
import usdtmore from '@/components/usdtmore'
import password from '@/components/password'
import welfare from '@/components/welfare'
import betRecord from '@/components/betRecord'
import activityRecord from '@/components/activityRecord'
import transRecord from '@/components/transRecord'
import money from '@/components/money'
import recharge from '@/components/recharge'
import payInfo from '@/components/payInfo'
import withdrawal from '@/components/withdrawal'
import transfer from '@/components/transfer'
import concise from '@/components/mode/concise'


import banklist from '@/components/banklist'
import usdtlist from '@/components/usdtlist'
import zfblist from '@/components/zfblist'
import wxlist from '@/components/wxlist'
import xzrmblist from '@/components/xzrmblist'




import myhelp from '@/components/myhelp'
import securityCenter from '@/components/securityCenter'
import bindzfb from '@/components/bindzfb'
import bindxzrmb from '@/components/bindxzrmb'
import bindwx from '@/components/bindwx'

Vue.use(Router)

const router =  new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        },


        {
          path: '/zhongjian',
          name: 'zhongjian',
          component: zhongjian, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        },
        {
          path: '/xzrmblist',
          name: 'xzrmblist',
          component: xzrmblist, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }


        },
        {
          path: '/wxlist',
          name: 'wxlist',
          component: wxlist, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        },
        {
          path: '/activity',
          name: 'activity',
          component: activity, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/zhanzhu',
          name: 'zhanzhu',
          component: zhanzhu, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/mine',
          name: 'mine',
          component: mine, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false,//是否用缓存
            requireAuth: true,
          }
        },


        {
          path: '/kefu',
          name: 'kefu',
          component: kefu,

        }
      ]
    },{
      path: '/hongbao',
      name: 'hongbao',
      component: hongbao,

    },{
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    },
    {
      path: '/bindxzrmb',
      name: 'bindxzrmb',
      component: bindxzrmb,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    },

    {
      path: '/bindwx',
      name: 'bindwx',
      component: bindwx,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    },

    {
      path: '/securityCenter',
      name: 'securityCenter',
      component: securityCenter,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    },

    {
      path: '/app',
      name: 'app',
      component: app, meta: {
        keepAlive: true,//是否缓存组件

        useCatch: false,//是否用缓存
        requireAuth: true,

      }

    },
    {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,

    }, {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,
    },{
      path: '/wenInfo',
      name: 'wenInfo',
      component: wenInfo,
    },  {
      path: '/zhanzhuye',
      name: 'zhanzhuye',
      component: zhanzhuye,
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    }, {
      path: '/applyagent',
      name: 'applyagent',
      component: applyagent,


    }, {
      path: '/boutBallBet',
      name: 'boutBallBet',
      component: boutBallBet,
    }, {
      path: '/boutBallBetInfo',
      name: 'boutBallBetInfo',
      component: boutBallBetInfo,
    }, {
      path: '/message',
      name: 'message',
      component: message, meta: {
        requireAuth: true,
      }
    }, {
      path: '/fanshui',
      name: 'fanshui',
      component: fanshui, meta: {
        requireAuth: true,
      }
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/userCent',
      name: 'userCent',
      component: userCent,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addBankCard',
      name: 'addBankCard',
      component: addBankCard,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/zfblist',
      name: 'zfblist',
      component: zfblist,
      meta: {
        requireAuth: true,
      }
    }



    , {
      path: '/addUsdtCard',
      name: 'addUsdtCard',
      component: addUsdtCard,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/usdtmore',
      name: 'usdtmore',
      component: usdtmore,

    }, {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/welfare',
      name: 'welfare',
      component: welfare,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/betRecord',
      name: 'betRecord',
      component: betRecord,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/activityRecord',
      name: 'activityRecord',
      component: activityRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/transRecord',
      name: 'transRecord',
      component: transRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/bindzfb',
      name: 'bindzfb',
      component: bindzfb,
      meta: {
        requireAuth: true,
      }
    },{
      path: '/money',
      name: 'money',
      component: money,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,


    }, {
      path: '/concise',
      name: 'concise',
      component: concise,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    },

    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        requireAuth: true,

      }
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        requireAuth: true,

      }
    }
    , {
      path: '/myhelp',
      name: 'myhelp',
      component: myhelp,
      meta: {
        requireAuth: true,

      }
    },
    {
      path: '/banklist',
      name: 'banklist',
      component: banklist,
      meta: {
        requireAuth: true,

      }
    },
    {
      path: '/usdtlist',
      name: 'usdtlist',
      component: usdtlist,
      meta: {
        requireAuth: true,

      }
    }

    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})


// 全局前置守卫
router.beforeEach((to, from, next) => {


  if(to.path == '/' || to.path == '/wxlist'  || to.path == '/xzrmblist' || to.path == '/zfblist'  || to.path == '/usdtlist'  || to.path == '/activity'  || to.path == '/bindxzrmb'   || to.path == '/bindwx'  || to.path == '/bindzfb' || to.path == '/securityCenter' || to.path == '/myhelp' || to.path == '/zhongjian'  || to.path == '/banklist' || to.path == '/addUsdtCard' || to.path == '/money' || to.path == '/mine'  || to.path == '/recharge'   || to.path == '/transfer'   || to.path == '/addUsdtCard'   || to.path == '/withdrawal'){

    document.documentElement.style.fontSize = '21.5px'

  } else {

    if(to.path == '/vip'){
      document.documentElement.style.fontSize = '60px'
    } else {
      document.documentElement.style.fontSize = '39px'
    }
  }

  if( to.path == '/recharge'  || to.path == '/wxlist'  || to.path == '/xzrmblist'   || to.path == '/zfblist'  || to.path == '/usdtlist'  || to.path == '/bindzfb'  || to.path == '/bindxzrmb'  || to.path == '/bindwx'    || to.path == '/myhelp' || to.path == '/securityCenter'  || to.path == '/transfer'  || to.path == '/banklist'  || to.path == '/addUsdtCard' || to.path == '/money'  || to.path == '/withdrawal'  || to.path == '/addUsdtCard') {
    document.body.style.fontSize = '12px'
  } else {
    document.body.style.fontSize = '21.5px'
  }


  console.log('全局前置守卫 - 路由即将改变', from.path, '→', to.path)
  // 可以在这里执行全局逻辑
  next() // 必须调用 next() 才能继续导航
})

// // 全局后置钩子
// router.afterEach((to, from) => {
//   console.log('全局后置钩子 - 路由已经改变', from.path, '→', to.path)
//   // 可以在这里执行全局逻辑，不需要 next 函数
// })


export default router



// WEBPACK FOOTER //
// ./src/router/index.js
